import { fetchEndpoint } from '../server/network'

// 文章列表
export const articleList = (id, page, per_page) =>
	fetchEndpoint('/v2/ecapi.article.list', 'POST', {
		id: id, // 文章ID
		page: page, // 当前第几页
		per_page: per_page // 每页多少
	})

export const journalism = () => fetchEndpoint('/v2/ecapi.article.journalism', 'POST', {})


export const articleInfo = (id) =>
	fetchEndpoint('/v2/ecapi.article.info', 'POST', {
		id: id, // 文章ID
	})


	export const technicalList = (data) =>
	fetchEndpoint('/v2/ecapi.technical.services.list', 'POST', {
		custom_id: data.custom_id,
		keyword: data.keyword, // 关键字
		page: data.page, // 当前第几页
		per_page: data.per_page // 每页多少
	})

	export const technicalInfo = (id) =>
		fetchEndpoint('/v2/ecapi.technical.services.get', 'POST', {
			id: id,
		})




// WEBPACK FOOTER //
// ./src/api/article.js